import createMessages from 'mz-intl/create';

export default createMessages('SEARCH_RESULTS', {
  ATTENTION: 'Attention',
  HOURLY_NOTICE:
    'All prices are for the entire duration of the trip and are valid within the pickup city only.',
  SEARCH_BUTTON_TOOLTIP: 'Click search to update the results',
  SEARCH_NO_START_LOCATION: 'Search must have a start location',
  SEARCH_NO_END_LOCATION: 'Search must have an end location',
  INCOMPLETE_ADDRESS_TITLE: 'Incomplete Address',
  INCOMPLETE_ADDRESS_PARAGRAPH:
    'One of the addresses you provided is not specific enough. In order to give you the correct prices and availability please update the address below by selecting some specific building or hotel.',
  SEARCH_FORM_FROM_TITLE: 'From',
  SEARCH_FORM_TO_TITLE: 'To',
  INCORRECT_ADDRESS_SUBMIT_BUTTON: 'Update',
  BNPL_BANNER_TITLE: 'Book now, pay later',
  BNPL_BANNER_TEXT:
    'Secure your client’s booking and price today. Payment will be charged on {date}. Cancel anytime before then at no cost.',
  PAY_LATER_UNAVAILABLE_TEXT:
    'Sorry, this provider doesn’t support book now, pay later. You can continue to checkout to pay now, or select another ride.',
  PAY_LATER_UNAVAILABLE_CONTINUE: 'Continue',
  PAY_LATER_UNAVAILABLE_SELECT_ANOTHER: 'Select another ride',
});
